import { defineComponent as _defineComponent } from 'vue';
import { useActions, useGetters, useState } from "vuex-composition-helpers";
import { useRoute } from "vue-router/composables";
import moment from 'moment';
import { computed, onMounted } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Logs',
    setup(__props) {
        const headers = [
            {
                text: "Date time",
                align: "start",
                value: "createdAt",
                width: '20%'
            },
            {
                text: "Content",
                align: "start",
                value: "text"
            },
        ];
        function formatDate(date) {
            return moment(date).format('MMM D YYYY, h:mm:ss a');
        }
        const feedId = useRoute().params.id;
        const queryParams = computed(() => {
            const baseQuery = {
                $limit: 1000,
                $sort: {
                    createdAt: -1
                }
            };
            if (feedId)
                baseQuery.feedId = feedId;
            return baseQuery;
        });
        const { find: fetchLogs } = useActions('schedule-log', ['find']);
        onMounted(() => fetchLogs({ query: queryParams.value }));
        const { isFindPending: areLogsLoading } = useState('schedule-log', ['isFindPending']);
        const { find: findLogsFromStore } = useGetters('schedule-log', ['find']);
        const scheduleLogs = computed(() => {
            if (!findLogsFromStore.value)
                return [];
            return findLogsFromStore.value({ query: queryParams.value }).data;
        });
        return { __sfc: true, headers, formatDate, feedId, queryParams, fetchLogs, areLogsLoading, findLogsFromStore, scheduleLogs };
    }
});
